import SearchPagination from './search-pagination';

export default SearchPagination;
